<template>
  <LibraryListItem>
    <div class="text-h2 text-textDarkest pl-4">
      {{ title }}
    </div>

    <div class="text-h2 text-textLighter w-100 d-flex justify-space-between">
      <div>
        {{ jobCode }}
      </div>
      <div>
        {{ jobLevel }}
      </div>
      <div>
        as of {{ effectiveDate }}
      </div>
    </div>
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';

defineProps({
  title: { type: String, default: '' },
  jobCode: { type: String, default: '' },
  effectiveDate: { type: String, default: '' },
  jobLevel: { type: String, default: '' },
});
</script>

<style lang="less" scoped>
.document-list-item {
  grid-template-columns: repeat(2, 1fr);
}
</style>
